class AlertsEventsDispatcher {
    showAlert(type, content) {
        const event = new CustomEvent('showAlert', {
            detail: { type, content },
        });
        document.dispatchEvent(event);
    }
}
export { AlertsEventsDispatcher };
//# sourceMappingURL=alerts-events-dispatcher.js.map